import { InboxNotificationResponse } from '../services/api/inboxApi';
import { API } from '../utils/AmplifyApiUtils';

export default class InboxClient {
  /**
   * Get inbox notification using group id
   * @param groupID // this is the notification group id
   */
  static NotificationByGroupId(
    groupID: string,
  ): Promise<InboxNotificationResponse[]> {
    return API.get('AppAPI', `/notifications`, {
      queryStringParameters: {
        groupID,
      },
    });
  }
}
